import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityRef, EntityType } from 'src/app/core/settings/settings.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EntitySearchService {
  entitySearchUrl: string = environment.entitySearch;

  constructor(private httpClient: HttpClient) {}

  getEntityById(entityType: EntityType, entityId: string): Promise<Entity> {
    const url = `${this.entitySearchUrl}/entity/${entityType}/${entityId}`;
    return this.httpClient.get<Entity>(url).toPromise();
  }

  getEntitiesById(
    entityType: EntityType,
    entityIds: string[],
  ): Promise<Entity[]> {
    const url = `${this.entitySearchUrl}/entities/${entityType}/id`;
    return this.httpClient.post<Entity[]>(url, entityIds).toPromise();
  }

  searchEntities(searchTerm: string): Promise<Entity[]> {
    return this.searchEntitiesObservable(searchTerm).toPromise();
  }

  searchEntitiesObservable(
    searchTerm: string,
    companyId?: number,
    entityTypes?: EntityType[],
  ): Observable<Entity[]> {
    let url = `${this.entitySearchUrl}/entities?query=${encodeURIComponent(searchTerm)}&limit=50`;
    if (companyId) {
      url = url + `&companyId=${companyId}`;
    }

    entityTypes?.forEach((et) => {
      url = url + `&entityTypes=${et}`;
    });

    return this.httpClient.get<Entity[]>(url);
  }
}

export interface Entity {
  id: string;
  path: EntityRef[];
  name: string;
  entityType: EntityType;
  rootGroupId: string;
}
